<mat-chip
    [disabled]="!isMostRecentFilter && addedFilterLength > 1"
    [ngClass]="{ disabled: !isMostRecentFilter && addedFilterLength > 1 }"
    #menuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="selectionMenu"
    (click)="onFilterClick()">
    <mat-icon class="remove_filter_icon" matChipRemove (click)="removeFilter()"
        >cancel
    </mat-icon>

    <ng-container [ngSwitch]="filter.filterOptionType">
        <ng-container *ngSwitchCase="dataTypeEnum.HeadingAndPictureUrl">
            <span>{{ filter.name }}</span>
            <div
                *ngFor="let option of selectedOptions | slice : 0 : 3"
                class="user_image">
                <img
                    alt=""
                    class="filter_round_image"
                    src="{{ option.pictureUrl }}" />
            </div>
            <div
                *ngIf="selectedOptions?.length > 3"
                class="user_image extra-count">
                +{{ selectedOptions?.length - 3 }}
            </div>
            <mat-icon class="toolbar_icon_colour"> arrow_drop_down </mat-icon>
        </ng-container>

        <ng-container *ngSwitchCase="dataTypeEnum.HeadingOnly">
            <span *ngIf="selectedOptions?.length == 0">{{ filter.name }}</span>
            <div
                *ngFor="
                    let option of selectedOptions | slice : 0 : 3;
                    let i = index
                ">
                {{ option.heading }}
                <span
                    *ngIf="i !== selectedOptions.length - 1 && i !== 2"
                    class="divider-line">
                    |
                </span>
            </div>
            <div
                *ngIf="selectedOptions?.length > 3"
                class="extra-count default-extra-count">
                +{{ selectedOptions?.length - 3 }}
            </div>
            <mat-icon class="toolbar_icon_colour"> arrow_drop_down </mat-icon>
        </ng-container>
    </ng-container>
</mat-chip>

<mat-menu #selectionMenu="matMenu" #matMenu="matMenu" class="user_menu">
    <div class="search_task_item_container">
        <input
            autocomplete="off"
            (click)="$event.stopPropagation()"
            [formControl]="search"
            id="task_menu_search"
            mat-menu-item
            matInput
            placeholder="Search" />
        <div class="search-box-spinner" *ngIf="dataLoading">
            <mat-spinner [diameter]="20"></mat-spinner>
        </div>
    </div>

    <ng-container *ngIf="{ data: data$ | async } as temp">
        <ng-container *ngIf="temp.data">
            <ng-container *ngIf="temp.data.length; else empty">
                <button
                    *ngFor="let option of temp.data"
                    mat-menu-item
                    [ngClass]="option.isSelected ? 'selected' : 'unselected'"
                    (click)="selectOption(option, filter)">
                    <div class="user_task_profile menu">
                        <div
                            *ngIf="option.pictureUrl"
                            [style.backgroundImage]="
                                'url(' + option.pictureUrl + ')'
                            "
                            class="task__profile"
                            mat-card-avatar></div>
                        <div class="option-heading">
                            {{ option.heading }}
                        </div>
                    </div>
                </button>
            </ng-container>
        </ng-container>
        <ng-template #empty>
            <div class="empty-results-wrapper">
                <span>No results found</span>
            </div>
        </ng-template>
    </ng-container>
</mat-menu>
